import {AfterViewInit, Component, Input} from '@angular/core';
import {NgIf} from "@angular/common";
import {Router} from "@angular/router";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {ClaimDto} from "../../../../auto-generated-server-dtos/claim/claim-dto";
import * as feather from "feather-icons";

@Component({
  selector: 'app-update-modal',
  standalone: true,
    imports: [
        NgIf
    ],
  templateUrl: './update-modal.component.html',
  styleUrl: './update-modal.component.scss'
})
export class UpdateModalComponent implements AfterViewInit {
  @Input() claimDto!: ClaimDto;

  constructor(private router: Router, public activeModal: NgbActiveModal) {
  }

  ngAfterViewInit() {
    feather.replace();
  }

  viewClaim(): void {
    this.activeModal.close();
    this.router.navigate(['/adjuster/claim', this.claimDto.claimId]).then();
  }

  returnToClaimsList(): void {
    this.activeModal.close();
    this.router.navigate(['/adjuster/claim-list']).then();
  }
}
